import * as React from 'react';

function SvgNoPending(props) {
  return (
    <svg width={78} height={104} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 79.852l11-9.485V34.678l-11 10v35.174zM65 34.678l10 10v36.975L65 71.067V34.678z"
        fill="#EDEDED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.514 34.678H12v37a5 5 0 005 5h43a5 5 0 005-5v-37h-9.81a5 5 0 00-5 5v4.86H26.514v-4.86a5 5 0 00-5-5zm-8.514 37v-36h8.514a4 4 0 014 4v5.86H51.19v-5.86a4 4 0 014-4H64v36a4 4 0 01-4 4H17a4 4 0 01-4-4z"
        fill="#E7E7E7"
      />
      <path
        d="M13 35.678v36a4 4 0 004 4h43a4 4 0 004-4v-36h-8.81a4 4 0 00-4 4v5.86H25.514v-5.86a4 4 0 00-4-4H13z"
        fill="#F8F8F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 44.678v37a5 5 0 005 5h64a5 5 0 005-5v-37l-10-10h-9.81a5 5 0 00-5 5v4.86H26.514v-4.86a5 5 0 00-5-5H12l-11 10zm1 37V45.121l10.386-9.443h9.128a4 4 0 014 4v5.86H51.19v-5.86a4 4 0 014-4h9.395L74 45.092v36.586a4 4 0 01-4 4H6a4 4 0 01-4-4z"
        fill="#E7E7E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.265 44.678H1v37a5 5 0 005 5h64a5 5 0 005-5v-37H59.322a5 5 0 00-5 5v4.86H21.265v-4.86a5 5 0 00-5-5zM2 81.678v-36h14.265a4 4 0 014 4v5.86h35.057v-5.86a4 4 0 014-4h14.677v36a4 4 0 01-4 4H6a4 4 0 01-4-4z"
        fill="#E7E7E7"
      />
      <path
        d="M2 45.678v36a4 4 0 004 4h64a4 4 0 004-4v-36H59.322a4 4 0 00-4 4v5.86H20.265v-5.86a4 4 0 00-4-4H2z"
        fill="#F9F9F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.073 17.305l-5.1-16.227.954-.3 5.1 16.227-.954.3zm23.135 6.333L57.63 6.703l.934.354-6.421 16.935-.935-.354zm7.059 1.518l18.684-10.49.49.873-18.685 10.49-.49-.873zM.3 8.278l11.99 16.39.807-.59-11.99-16.39-.807.59z"
        fill="#E7E7E7"
      />
      <ellipse cx={39.499} cy={101.678} rx={29.5} ry={2} fill="#F8F8F6" />
    </svg>
  );
}

export default SvgNoPending;
